<template>
    <div>
        <div class="columns is-multiline m-b-15">
            <div class="column is-full">
                <a 
                class="has-text-danger m-b-20"
                @click="emitDelete">
                    <b-icon icon="trash" size="is-small"></b-icon> Delete
                </a>
                <b-field label="Precio especial">
                    <b-switch
                    v-model="data.hasDifPricing">
                    </b-switch>
                </b-field>
            </div>
            <div v-for="x in getAttributes" class="column is-one-fifth"  :key="x.title">
                
                <b-field :label="x.title ? x.title : 'Attributo'">
                         <b-select 
                         placeholder="Pick a value" 
                         v-model="data[x.title]"
                         v-on:input="updateVariant({index, data})">
                            <option v-for="v in x.values" :value="v" :key="v">{{v}}</option>
                        </b-select>
                </b-field>
            </div>
            <div v-if="data.hasDifPricing" class="column is-one-fifth">
                <b-field label="Precio">
                    <b-numberinput 
                    v-model="data.price" 
                    min="0" 
                    type="is-light"
                    controls-rounded
                    v-on:input="updateVariant({index, data})">
                    </b-numberinput>
                </b-field>
            </div>  
            <div v-if="data.hasDifPricing" class="column is-one-fifth">
                <b-field label="Costo">
                    <b-numberinput 
                    v-model="data.cost" 
                    min="0" 
                    type="is-light"
                    controls-rounded
                    v-on:input="updateVariant({index, data})">
                    </b-numberinput>
                </b-field>
            </div>
            <div v-if="data.hasDifPricing" class="column is-one-fifth">
                <b-field label="Comparar a">
                    <b-numberinput 
                    v-model="data.compareAt" 
                    min="0" 
                    type="is-light"
                    controls-rounded
                    v-on:input="updateVariant({index, data})">
                    </b-numberinput>
                </b-field>
            </div>
            <div v-if="getInventory.trackStock" class="column is-one-fifth">
                <b-field label="Stock">
                    <b-numberinput 
                    v-model="data.quantity" 
                    min="0" 
                    type="is-light"
                    controls-rounded
                    v-on:input="updateVariant({index, data})">
                    </b-numberinput>
                </b-field>
            </div>
            <div class="column is-one-fifth" v-if="getInventory.trackStock">
                <b-field label="Codigo">
                    <b-input 
                    type="text"
                    v-model="data.code" 
                    v-on:input="updateVariant({index, data})">
                    </b-input>
                </b-field>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex"


export default {
    props:{
        index:{
            type:Number,
            default:0
        },
        data:{
            type:Object,
            default: new Object({})
        }
    },
    computed:{
        ...mapGetters(['getAttributes', 'getInventory']),
    },
    methods:{
        ...mapActions(["updateVariant"]),
        specialUpdate(payload){
            this.data = {price:this.data.price, cost:this.data.cost, hasDifPricing:this.data.hasDifPricing}
            let val = payload.event
            this.data[payload.title] = val
            this.updateVariant({index:this.index, data:this.data})
        },
        emitDelete(){
            this.$emit("deleteVar", this.index)
        }
    }
}
</script>

<style lang="scss" scoped>
.columns{
    border-top:0.8px solid #ddd;
    
}
</style>
